import { QueryKeysConfig } from "@/config/query-keys";
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { getColorScheme, setColorScheme } from "@/persistence/color-scheme";

export const useColorScheme = () => {
  return useSuspenseQuery({
    queryKey: [QueryKeysConfig.colorScheme],
    queryFn: getColorScheme,
    staleTime: Infinity,
    gcTime: Infinity,
  }).data;
};

export const useChangeColorScheme = () => {
  const queryClient = useQueryClient();
  return async (colorScheme: string) => {
    queryClient.setQueryData([QueryKeysConfig.colorScheme], colorScheme);
    setColorScheme(colorScheme);
  };
};
